import { useContext } from 'react';

import { TranslateContext } from './TranslateContext';

export function useTranslate() {
  const { lang, t } = useContext(TranslateContext);

  return { lang, t };
}
